import { useQuery } from "@tanstack/react-query";

import { apiRequest } from "@/lib/queryClient";
import type { Product } from "@/lib/types";

const PRODUCTS_KEY = "/api/products";

export function useProducts() {
  // 產品 CRUD 後對 [KEY] 前綴 invalidate，會同步刷新這裡的清單
  // （產品管理頁改抓 include_inactive 版本，兩邊不再共用同一個快取鍵）
  const query = useQuery<Product[]>({
    queryKey: [PRODUCTS_KEY, ""],
    queryFn: async () => {
      const res = await apiRequest("GET", PRODUCTS_KEY);
      return (await res.json()) as Product[];
    },
  });

  const products = query.data ?? [];

  const loadingStatus = query.isLoading
    ? "正在載入產品資料..."
    : query.isError
      ? "產品資料載入失敗"
      : "產品資料已載入完成";

  const searchProducts = (searchQuery: string): Product[] => {
    if (!searchQuery.trim()) {
      return [];
    }

    const normalizedQuery = searchQuery.toLowerCase();

    return products.filter((product) => {
      return (
        product.code.toLowerCase().includes(normalizedQuery) ||
        product.name.toLowerCase().includes(normalizedQuery) ||
        (product.color && product.color.toLowerCase().includes(normalizedQuery))
      );
    });
  };

  return {
    products,
    isLoadingProducts: query.isLoading,
    loadingStatus,
    fetchProducts: query.refetch,
    searchProducts,
  };
}
